import { RegistrarVisitaMasivaComponent } from './registrar-visita-masiva.component';
import { NotFoundComponent } from './../../shared/components/notFound/not-found.component';
import { AuthGuard } from '../../shared/guards/authGuard/auth.guard';
import { MainframeComponent } from './../mainframe/mainframe.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [
    { path: '', component: RegistrarVisitaMasivaComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes), FormsModule, ReactiveFormsModule],
    exports: [RouterModule]
})
export class RegistrarVisitaMasivaRoutingModule { }
